exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3qLsA{background-color:#fff;padding:0 20px;margin-bottom:20px;font-size:13px;font-weight:400}._3qLsA,._34yh6{position:relative}._34yh6{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-ms-flex-wrap:nowrap;flex-wrap:nowrap}._3F3jq{position:relative;color:#2196f3;text-decoration:none;padding-right:10px}._3F3jq:after{content:\" \";width:14px;height:40px;display:inline-block;position:absolute;top:-1px;right:0}._2WBs_ img,._3F3jq img{position:relative;top:-2px;margin-right:.2em}._2WBs_ img{margin-right:0;margin-left:.2em}._2WBs_{color:#2196f3;text-decoration:none}.pD8Eo{position:relative;display:inline-block;margin:0 4px}._1wCUi{vertical-align:baseline;line-height:38px}._3aY3r{width:calc(100% - 210px)}._3AWpp{position:relative;display:inline-block;color:#000;padding:0 4px;text-decoration:none}._3AWpp:first-letter{text-transform:capitalize}._3AWpp:hover{color:#2196f3}._3wcxk{max-width:250px;-o-text-overflow:ellipsis;text-overflow:ellipsis;white-space:nowrap;overflow:hidden;vertical-align:top}._3wcxk:hover{color:#000}._2bGUz{text-align:right;width:210px;white-space:nowrap;-ms-flex-wrap:nowrap;flex-wrap:nowrap;line-height:38px;vertical-align:baseline}", ""]);

// exports
exports.locals = {
	"root": "_3qLsA",
	"flexRow": "_34yh6 flexRow",
	"back": "_3F3jq",
	"next": "_2WBs_",
	"divider": "pD8Eo",
	"container": "_1wCUi",
	"left": "_3aY3r",
	"select": "_3AWpp",
	"current": "_3wcxk",
	"right": "_2bGUz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/Breadcrumbs/Breadcrumbs.css
// module id = 2060
// module chunks = 15 17 21 36